import React from "react";

const STANDARD_LAYOUT_SECTION_IDS = new Set([
    "sijisu",
    "sozai_meisai",
    "fuzoku_meisai",
    "hinshitsu",
    "hoteigai",
    "fukiyogo",
    "koseibuhin"
]);

function renderEmptyBody() {
    return (
        <div
            style={{
                minHeight: 44,
                border: "1px solid #d0d0d0",
                borderRadius: 4,
                backgroundColor: "#fafafa",
                padding: "10px 12px",
                color: "#666"
            }}
        >
        </div>
    );
}

export function isStandardLayoutSection(section) {
    const sectionId = String(section?.id ?? "").trim();
    return STANDARD_LAYOUT_SECTION_IDS.has(sectionId);
}

export function renderStandardLayoutSectionBody({
    section,
    sectionPanel,
    gridSectionPanel,
    stableGridPanel,
    resolvedTotalType,
    rowStyle,
    renderContents,
    renderTotalGrid,
    sectionTotalType,
    toStableAutoHeightPanel,
    isEmpty
}) {
    const hasGridPanel = !isEmpty(gridSectionPanel);
    const renderPanel = hasGridPanel
        ? (stableGridPanel || toStableAutoHeightPanel(gridSectionPanel, section.id))
        : sectionPanel;

    let body = renderEmptyBody();
    if (!isEmpty(renderPanel)) {
        const contentProps = { panel: renderPanel };
        if (hasGridPanel) contentProps.getRowStyle = rowStyle;
        body = renderContents(contentProps);
    }

    const totaltype = resolvedTotalType || sectionTotalType(section, gridSectionPanel || sectionPanel);
    if (isEmpty(totaltype) || isEmpty(gridSectionPanel)) {
        return body;
    }

    return (
        <div>
            {body}
            {renderTotalGrid(section, renderPanel, totaltype, false, section.id === "sijisu")}
        </div>
    );
}
